// import React, { useState } from "react";
// import axios from "axios";
// import MDBox from "components/MDBox";
// import MDInput from "components/MDInput";
// import MDTypography from "components/MDTypography";

// export default function Search() {
//   const [org, setOrg] = useState("");
//   const [results, setResults] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);

//   const fetchOrgs = async (query) => {
//     try {
//       const token = localStorage.getItem("token");

//       // ✅ replace `https://v` with your real base URL
//       const res = await axios.get(
//         `https://v3.dhundhoo.com/superAdmin/search/get/org/${query}`,
//         {
//           headers: { "x-dhundhoo-session": token },
//         }
//       );

//       console.log("🔍 API Response:", res.data);

//       // ✅ API returns array directly
//       if (Array.isArray(res.data) && res.data.length > 0) {
//         setResults(res.data);
//         setShowDropdown(true);
//       } else {
//         setResults([]);
//         setShowDropdown(false);
//       }
//     } catch (error) {
//       console.error("❌ Error fetching orgs:", error);
//       setResults([]);
//       setShowDropdown(false);
//     }
//   };

//   const handleChange = (e) => {
//     const value = e.target.value;
//     setOrg(value);

//     if (value.trim() !== "") {
//       fetchOrgs(value);
//     } else {
//       setResults([]);
//       setShowDropdown(false);
//     }
//   };

//   const handleSelect = (item) => {
//     const selectedName = item.orgInfo?.orgName || "Unnamed Org";
//     setOrg(selectedName);
//     setShowDropdown(false);
//   };

//   return (
//     <MDBox
//       display="flex"
//       flexDirection="column"
//       alignItems="center"
//       justifyContent="flex-start"
//       gap={3}
//       sx={{
//         width: "100%",
//         minHeight: "100vh",
//         backgroundColor: "#fff",
//         py: 5,
//       }}
//     >
//       <MDBox
//         display="flex"
//         flexDirection="column"
//         alignItems="center"
//         sx={{
//           width: "60%",
//           backgroundColor: "white",
//           borderRadius: 2,
//           p: 3,
//         }}
//       >
//         {/* 🔍 Input */}
//         <MDInput
//           label="Search Organization"
//           value={org}
//           onChange={handleChange}
//           fullWidth
//         />

//         {/* 📋 Dropdown Results */}
//         {showDropdown && results.length > 0 && (
//           <MDBox
//             sx={{
//               mt: 1,
//               width: "100%",
//               border: "1px solid #ddd",
//               borderRadius: 1,
//               backgroundColor: "#fff",
//               maxHeight: 200,
//               overflowY: "auto",
//             }}
//           >
//             {results.map((item, index) => {
//               const orgName = item.orgInfo?.orgName || "Unnamed Org";
//               const address = item.orgInfo?.address || "No address available";

//               return (
//                 <div
//                   key={index}
//                   style={{
//                     padding: "10px 12px",
//                     cursor: "pointer",
//                     borderBottom: "1px solid #eee",
//                   }}
//                   onClick={() => handleSelect(item)}
//                 >
//                   <MDTypography variant="body2" fontWeight="medium">
//                     {orgName}
//                   </MDTypography>
//                   <MDTypography variant="caption" color="textSecondary">
//                     {address}
//                   </MDTypography>
//                 </div>
//               );
//             })}
//           </MDBox>
//         )}
//       </MDBox>
//     </MDBox>
//   );
// }
import React, { useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import WalletForm from "./WalletForm";


export default function Search() {
  const [org, setOrg] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [walletData, setWalletData] = useState({
    subscriptionType: "",
    expiryDate: "",
    accountBalance: "",
    addAmount: "",
  });

  // 🔹 Fetch orgs on search
  const fetchOrgs = async (query) => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://v3.dhundhoo.com/superAdmin/search/get/org/${query}`,
        {
          headers: { "x-dhundhoo-session": token },
        }
      );

      console.log("🔍 Search API:", res.data);

      if (Array.isArray(res.data) && res.data.length > 0) {
        setResults(res.data);
        setShowDropdown(true);
      } else {
        setResults([]);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error("❌ Error fetching orgs:", error);
      setResults([]);
      setShowDropdown(false);
    }
  };

  // 🔹 Handle search input
  const handleChange = (e) => {
    const value = e.target.value;
    setOrg(value);

    if (value.trim() !== "") {
      fetchOrgs(value);
    } else {
      setResults([]);
      setShowDropdown(false);
    }
  };

  // 🔹 On selecting organization
  const handleSelect = async (item) => {
    setOrg(item.orgInfo?.orgName || "Unnamed Org");
    setSelectedOrg(item);
    setShowDropdown(false);

    try {
      const token = localStorage.getItem("token");
      const orgHandle = item.orgInfo?.orgHandle;

      const res = await axios.get(
        `https://v3.dhundhoo.com/wallet/amount/${orgHandle}`,
        {
          headers: { "x-dhundhoo-session": token },
        }
      );

      console.log("💰 Wallet Data:", res.data);

      setWalletData({
        subscriptionType: res.data.subscriptionType ?? "",
        expiryDate: res.data.expiryDate ?? "",
        accountBalance: res.data.remainingAmount ?? "",
        addAmount: "",
      });
    } catch (error) {
      console.error("❌ Error fetching wallet info:", error);
    }
  };

  // 🔹 Handle form field changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setWalletData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Submit wallet data
  const handleFormSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      const payload = {
        orgHandle: selectedOrg?.orgInfo?.orgHandle,
        enableWallet: true,
        subscriptionType: Number(walletData.subscriptionType) ?? 0,
        amount: walletData.addAmount || 0,
      };

      console.log("🟢 Submitting Wallet:", payload);

      const res = await axios.post("https://v3.dhundhoo.com/wallet", payload, {
        headers: { "x-dhundhoo-session": token },
      });

      console.log("✅ Wallet updated:", res.data);
      alert("Wallet updated successfully!");
    } catch (error) {
      console.error("❌ Error submitting wallet:", error);
      alert("Failed to update wallet.");
    }
  };

  // 🔹 Clear form fields
  const handleFormClear = () => {
    setWalletData({
      subscriptionType: "",
      expiryDate: "",
      accountBalance: "",
      addAmount: "",
    });
  };

  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      gap={3}
      sx={{
        width: "100%",
        minHeight: "100vh",
        // backgroundColor: "#fff",
        py: 5,
      }}
    >
      {/* 🔍 Search Box */}
      <MDBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          width: "60%",
          // backgroundColor: "white",
          borderRadius: 2,
          p: 3,
        }}
      >
        <MDInput
          label="Search Organization"
          value={org}
          onChange={handleChange}
          fullWidth
        />

        {/* 📋 Dropdown results */}
        {showDropdown && results.length > 0 && (
          <MDBox
            sx={{
              mt: 1,
              width: "100%",
              border: "1px solid #ddd",
              borderRadius: 1,
              backgroundColor: "#fff",
              maxHeight: 200,
              overflowY: "auto",
            }}
          >
            {results.map((item, index) => {
              const orgName = item.orgInfo?.orgName || "Unnamed Org";
              const address = item.orgInfo?.address || "No address available";

              return (
                <div
                  key={index}
                  style={{
                    padding: "10px 12px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                  }}
                  onClick={() => handleSelect(item)}
                >
                  <MDTypography variant="body2" fontWeight="medium" color="textSecondary">
                    {orgName}
                  </MDTypography>
                  <MDTypography variant="caption" color="textSecondary">
                    {address}
                  </MDTypography>
                </div>
              );
            })}
          </MDBox>
        )}
      </MDBox>

      {/* 💰 Wallet Form (only show after selecting org) */}
      {selectedOrg && (
        <WalletForm
          subscriptionType={walletData.subscriptionType}
          expiryDate={walletData.expiryDate}
          accountBalance={walletData.accountBalance}
          addAmount={walletData.addAmount}
          onChange={handleFormChange}
          onSubmit={handleFormSubmit}
          onClear={handleFormClear}
        />
      )}
    </MDBox>
  );
}